import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import {
  downloadSmsExportFile,
  MAX_SMS_EXPORT_DATE_RANGE_DAYS,
  smsTransactionDetail,
  smsTransactionDetailTenant,
  startSmsTransactionDetailExport,
  subscribeSmsExportEvents,
} from "../../libs/dashboard";
import {
  PreparingReportExportToast,
  ReadyReportExportToast,
} from "../../components/ReportExportToast";
import {
  buildReportFetchParams,
  refetchReportWithoutSearch,
  resetReportFilters,
} from "../../libs/reportFetchHelpers";
import { loggedInUsers } from "../../store/store";
import { formatNumber } from "../../libs/helper";
import ReportToolbar from "../../components/ReportToolbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import { Button, Progress } from "antd";

const SMS_EXPORT_TOAST_ID = "sms-transaction-detail-export";

const TooltipCell = ({ value }) => (
  <div
    title={value}
    style={{
      width: "400px",
    }}
  >
    <span>{value.length > 20 ? `${value.substring(0, 20)}...` : value}</span>
  </div>
);

const columns = [
  {
    name: "Id",
    selector: (row) => row.batchId,
    // width: "250px",
    cell: (row, index, column, id) => {
      return (
        <div
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            maxWidth: "90px",
            minWidth: "90px",
            textAlign: "left",
            padding: "3px",
          }}
        >
          {row.batchId}
        </div>
      );
    },
  },
  {
    name: "Created At",
    selector: (row) => row.createdAt,
    // width: "150px",
    cell: (row, index, column, id) => {
      return (
        <div
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            maxWidth: "90px",
            minWidth: "90px",
            textAlign: "left",
            padding: "3px",
          }}
        >
          {row.createdAt}
        </div>
      );
    },
  },
  {
    name: "Status",
    selector: (row) => row.status,
    cell: (row, index, column, id) => {
      return (
        <div
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            // maxWidth: "70px",
            // minWidth: "70px",
            textAlign: "left",
            padding: "3px",
          }}
        >
          {row.status}
        </div>
      );
    },
    // width: "250px",
    sortable: true,
  },
  {
    name: "Message",
    selector: (row) => row.message,
    width: "250px",
    cell: (row, index, column, id) => {
      return (
        <div
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            textAlign: "left",
            padding: "10px 0px",
          }}
        >
          {row.message}
        </div>
      );
    },
  },
  {
    name: "Network",
    selector: (row) => row.network,
    // width: "120px",
    sortable: true,
  },
  {
    name: "Recipient",
    selector: (row) => row.recipient,
    // width: "110px",
  },
  {
    name: "Sender Id",
    selector: (row) => row.senderId,
    // width: "110px",
  },
  {
    name: "Sms Route",
    selector: (row) => (row.smsRoute ? row.smsRoute : row.smsType),
    // width: "110px",
  },
];

var CryptoJS = require("crypto-js");
let Fetch_values;

const SMShistory = () => {
  const { userdata } = loggedInUsers((state) => state.auth);
  // Decrypt
  var getUser = CryptoJS.AES.decrypt(
    userdata,
    process.env.REACT_APP_SOCKET_ENCRYPTION_KEY
  );
  var userD = JSON.parse(getUser.toString(CryptoJS.enc.Utf8));

  // Get today's date in YYYY-MM-DD format
  const todayDateString = dayjs().format("YYYY-MM-DD");

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [filterDate, setFilterDate] = useState([
    todayDateString,
    todayDateString,
  ]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [exportRowsWritten, setExportRowsWritten] = useState(0);
  const [readyExport, setReadyExport] = useState(null);
  const exportAbortRef = useRef(null);
  const readyExportRef = useRef({ jobId: null, fileName: null });

  const isTenantUser = userD?.userType === "user-group";

  useEffect(() => {
    return () => {
      exportAbortRef.current?.abort();
    };
  }, []);

  const loadReport = (overrides = {}) => {
    fetchData(
      buildReportFetchParams({
        perPage,
        filterDate,
        searchTerm,
        overrides,
      })
    );
  };

  useEffect(() => {
    loadReport({ page: 1 });
  }, [perPage]);

  const onDateChange = (value, dateString) => {
    if (value) {
      setFilterDate(dateString);
      fetchData(
        buildReportFetchParams({
          page: 1,
          perPage,
          filterDate: dateString,
          searchTerm,
        })
      );
    } else {
      setFilterDate(null);
      fetchData(
        buildReportFetchParams({
          page: 1,
          perPage,
          filterDate: null,
          searchTerm,
        })
      );
    }
  };

  // const fetchData = async (Fetch_values) => {
  //   setLoading(true);

  //   Fetch_values = Object.assign(
  //     Fetch_values,
  //     { email: userD?.email },

  //     { bearerToken: userD?.bearerToken }
  //   );
  //   const getSID = await smsTransactionDetail(Fetch_values);
  //   if (getSID) {
  //     setIsLoaded(true);
  //     setLoading(false);
  //     setItems(getSID.data);
  //     setTotalRows(getSID.headers["x-pagination-totalcount"]);
  //     // console.log("Fetching", loading);
  //   } else {
  //     setIsLoaded(true);
  //     setError(error);
  //   }
  // };

  const fetchData = async (Fetch_values) => {
    setLoading(true);

    const emailToUse = userD?.email;

    Fetch_values = Object.assign(
      Fetch_values,
      { email: emailToUse },
      { bearerToken: userD?.bearerToken }
    );

    try {
      let getSID;
      if (userD?.userType === "user-group") {
        getSID = await smsTransactionDetailTenant(Fetch_values);
      } else {
        getSID = await smsTransactionDetail(Fetch_values);
      }

      if (getSID) {
        setIsLoaded(true);
        setLoading(false);
        setItems(getSID.data);
        setTotalRows(getSID.headers["x-pagination-totalcount"]);
      } else {
        setIsLoaded(true);
        setError("No data returned");
      }
    } catch (error) {
      setIsLoaded(true);
      setError(error);
    }
  };

  const handlePageChange = (page) => {
    loadReport({ page });
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (!value) {
      refetchReportWithoutSearch({ filterDate, perPage, fetchData });
    }
  };

  const handleSubmitSearch = () => {
    loadReport({ page: 1 });
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      if (e.target.value?.trim()) {
        handleSubmitSearch();
      } else {
        setSearchTerm("");
        refetchReportWithoutSearch({ filterDate, perPage, fetchData });
      }
    }
  };

  const handleResetFilters = () => {
    resetReportFilters({
      todayDateString,
      perPage,
      setSearchTerm,
      setFilterDate,
      fetchData,
    });
  };

  const handleDownloadReport = async () => {
    if (isTenantUser || exportInProgress) {
      return;
    }

    if (!filterDate?.[0] || !filterDate?.[1]) {
      toast.error("Select a start and end date before downloading.");
      return;
    }

    const rangeDays = dayjs(filterDate[1]).diff(dayjs(filterDate[0]), "day");
    if (rangeDays > MAX_SMS_EXPORT_DATE_RANGE_DAYS) {
      toast.error(
        `Export date range cannot exceed ${MAX_SMS_EXPORT_DATE_RANGE_DAYS} days. Narrow your selection and try again.`
      );
      return;
    }

    exportAbortRef.current?.abort();
    const abortController = new AbortController();
    exportAbortRef.current = abortController;

    setExportInProgress(true);
    setExportRowsWritten(0);
    setReadyExport(null);

    try {
      const exportResp = await startSmsTransactionDetailExport({
        email: userD.email,
        bearerToken: userD.bearerToken,
        startDate: filterDate[0],
        endDate: filterDate[1],
        search: searchTerm,
      });

      const jobId = exportResp?.data?.data?.jobId;
      if (!jobId) {
        throw new Error("Export did not return a job id");
      }

      toast.info(<PreparingReportExportToast />, {
        toastId: SMS_EXPORT_TOAST_ID,
        autoClose: false,
      });

      await subscribeSmsExportEvents({
        jobId,
        bearerToken: userD.bearerToken,
        userId: userD.email,
        signal: abortController.signal,
        onEvent: (eventName, payload) => {
          const normalizedEvent = String(eventName || "").trim();

          if (normalizedEvent === "progress" && payload.rowsWritten != null) {
            setExportRowsWritten(Number(payload.rowsWritten) || 0);
            toast.update(SMS_EXPORT_TOAST_ID, {
              render: (
                <PreparingReportExportToast rowsWritten={payload.rowsWritten} />
              ),
              autoClose: false,
            });
          }

          if (normalizedEvent === "complete") {
            const readyFile = {
              jobId: payload.jobId,
              fileName: payload.fileName,
            };
            const downloadArgs = {
              jobId: payload.jobId,
              bearerToken: userD.bearerToken,
              userId: userD.email,
              fileName: payload.fileName,
            };
            readyExportRef.current = readyFile;
            setReadyExport(readyFile);
            toast.update(SMS_EXPORT_TOAST_ID, {
              render: (
                <ReadyReportExportToast
                  onDownload={() => downloadSmsExportFile(downloadArgs)}
                />
              ),
              autoClose: false,
            });
            setExportInProgress(false);
            downloadSmsExportFile(downloadArgs).catch((downloadError) => {
              console.error("Automatic report download failed", downloadError);
              toast.error(
                "The report is ready, but the download did not start. Use Download again to try."
              );
            });
            abortController.abort();
          }

          if (eventName === "error") {
            toast.dismiss(SMS_EXPORT_TOAST_ID);
            toast.error(payload.message || "Export failed");
            setExportInProgress(false);
            abortController.abort();
          }
        },
        onError: (error) => {
          if (error?.name === "AbortError") {
            return;
          }
          console.error("SSE export error", error);
          toast.dismiss(SMS_EXPORT_TOAST_ID);
          toast.error("Lost connection to export status. Check back shortly.");
          setExportInProgress(false);
        },
      });
      setExportInProgress(false);
    } catch (error) {
      if (abortController.signal.aborted) {
        return;
      }
      toast.dismiss(SMS_EXPORT_TOAST_ID);
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to start export";
      toast.error(message);
      setExportInProgress(false);
    }
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    // console.log("Log PerPage", perPage);
  };

  const dataRowStyles = {
    color: loading ? "gray" : "black", // Apply conditional color
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    return (
      <>
        <div className="App">
          <h1 className="text-xl font-semibold">SMS Transaction Details</h1>

          <p className="text-xs font-semibold mb-2">
            <span className="text-xl font-semibold">
              {formatNumber(totalRows)}
            </span>{" "}
            Records Found
          </p>
          {(exportInProgress || readyExport) && (
            <div className="mb-3 max-w-xl">
              <Progress
                percent={
                  readyExport
                    ? 100
                    : totalRows > 0
                      ? Math.min(
                          99,
                          Math.round((exportRowsWritten / totalRows) * 100)
                        )
                      : 0
                }
                status={readyExport ? "success" : "active"}
                format={() =>
                  readyExport
                    ? "Ready"
                    : `${formatNumber(exportRowsWritten)} rows written`
                }
              />
              {readyExport && (
                <Button
                  type="primary"
                  size="small"
                  onClick={() =>
                    downloadSmsExportFile({
                      jobId: readyExport.jobId,
                      bearerToken: userD.bearerToken,
                      userId: userD.email,
                      fileName: readyExport.fileName,
                    })
                  }
                >
                  Download again
                </Button>
              )}
            </div>
          )}
          <ReportToolbar
            filterDate={filterDate}
            onDateChange={onDateChange}
            searchTerm={searchTerm}
            searchInputValue={searchTerm}
            onSearchChange={handleSearchChange}
            onSearchKeyDown={handleKeypress}
            onSubmitSearch={handleSubmitSearch}
            onResetFilters={handleResetFilters}
            showDownload={!isTenantUser}
            onDownload={handleDownloadReport}
            downloadDisabled={
              exportInProgress || !filterDate?.[0] || !filterDate?.[1]
            }
          />
          <DataTable
            columns={columns}
            data={items}
            fixedHeader
            pagination
            highlightOnHover="true"
            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            customStyles={{
              rows: {
                style: dataRowStyles,
              },
            }}
          />
        </div>
        {/* <TableTest /> */}
        <ToastContainer autoClose={3000} theme="colored" newestOnTop={true} />
      </>
    );
  }
};

export default SMShistory;
